/*
 * @Author: 🐝
 * @Date: 2023-09-11 14:49:14
 * @LastEditors: Ant🐜
 * @LastEditTime: 2023-12-16 12:14:27
 * @Description: 描述一下
 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  } else {
    return null
  }
}

export function getUrlQuery(url) {
  if (url.indexOf('?') === -1) return ''
  let arr = url.split('?')
  if (!arr[1]) return ''
  return arr[1]
}

export const getLocal = name => {
  return localStorage.getItem(name)
}

export const setLocal = (name, value) => {
  localStorage.setItem(name, value)
}

// 图片前缀方法
export const prefix = url => {
  if (url && url.startsWith('http')) {
    return url
  } else {
    url = `http://backend-api-01.newbee.ltd${url}`
    return url
  }
}

function returnFloat(value) {
  value = Math.round(parseFloat(value) * 100) / 100
  var xsd = value.toString().split('.')
  if (xsd.length == 1) {
    value = value.toString() + '.00'
    return value
  }
  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      value = value.toString() + '0'
    }
    return value
  }
}

// 余额单位转化
export function balanceUnit(number) {
  //  Math.floor 向下取整
  let balance = 10000,
    data = {
      balance_c: number,
      balance: number,
      company: !number || number < balance ? '元' : balance <= number && number < balance * balance ? '万元' : '亿元'
    }
  if (typeof number !== 'number' && isNaN(number)) return data
  data.balance_c =
    number < balance
      ? number
      : balance <= number && number < balance * balance
      ? Math.floor((number / balance) * 100) / 100
      : Math.floor((number / (balance * balance)) * 100) / 100
  data.balance_c = returnFloat(Number(data.balance_c))
  data.balance = data.balance_c + data.company
  return data
}

export function formatDateTime(date) {
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  let second = date.getSeconds()
  second = second < 10 ? '0' + second : second
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
}

export function countTime(st) {
  const date = new Date(st).getTime() - new Date().getTime()
  const days = Math.floor(date / (24 * 3600 * 1000))
  const hours = Math.floor((date % (24 * 3600 * 1000)) / (3600 * 1000))
  const minutes = Math.floor(((date % (24 * 3600 * 1000)) % (3600 * 1000)) / (60 * 1000))
  const seconds = Math.round((((date % (24 * 3600 * 1000)) % (3600 * 1000)) % (60 * 1000)) / 1000)
  return (days ? `${days}天` : '') + `${hours}时` + (minutes ? `${minutes}分` : '')
}
